import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchSessionEngagementTotals } from '@/store/slices/project';
import { selectSessionEngagementTotals } from '@/store/slices/project/selectors';
import { useEffect, useRef } from 'react';

export const useLoadSessionEngagementTotals = (sessionUuid?: string | undefined) => {
  const dispatch = useAppDispatch();
  const sessionEngagementTotals = useAppSelector(selectSessionEngagementTotals);

  const fetching = useRef(false);

  useEffect(() => {
    if (!sessionUuid || fetching.current) return;

    fetching.current = true;

    (async () => {
      try {
        await dispatch(fetchSessionEngagementTotals({ sessionUuid }));
      } catch (error) {
        console.error(error);
      } finally {
        fetching.current = false;
      }
    })();
  }, [sessionUuid, sessionEngagementTotals?.length, dispatch]);
};
